import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './EarnText.module.scss'

const EarnText = ({ sum }) => {
    const { t } = useTranslation()

    return (
        <div className={styles.earnText}>
            {t('Your earnings')}
            <span className={styles.sum}>${sum}</span>
        </div>
    )
}

export default EarnText
